import { all } from 'redux-saga/effects'
import campaignSummarySaga from '../components/CampaignSummary/campaignSummary.saga'
import createCampaignSagas from '../containers/CreateCampaigns/createCampaignSagas'
import createSegmentsSaga from '../containers/CreateSegments/createSegmentsSagas'
import viewCampaignSagas from '../containers/ViewCampaigns/viewCampaignsSagas'
import viewSegmentsSagas from '../containers/ViewSegments/viewSegmentsReducerSagas'


export default function* rootSaga() {
  yield all([
    //Add your sagas here
    createCampaignSagas(),
    viewCampaignSagas(),
    createSegmentsSaga(),
    viewSegmentsSagas(),
    campaignSummarySaga()
  ])
}